import React from "react";
import { Redirect } from "react-router-dom";
import ProtectedRoute from "../pages/Utility/TaxProtectedRoute";

// Profile
import UserProfile from "../pages/Authentication/user-profile";
import PaymentPreference from "../pages/PaymentPreference/index";
import Dividends from "../pages/Dividends/index";

// Authentication
import Login from "../pages/Authentication/Login";
import Googleauth from "../pages/Authentication/googleauth";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgotPassword";
import ChangePwd from "../pages/Authentication/ChangePassword";
import MobileVerification from "../pages/Authentication/MobileVerification";
import KycDetails from "../pages/Authentication/KycDetails";
import Changepassword from "../pages/ChangePassword/ChangePassword";
import Twofaauthenticator from "../pages/TWOFAAuthenticator/Twofaauthenticator";
import Properties from "../pages/Property/index";
import PropertyDetails from "../pages/Property/PropertyDetails";
import KYCSuccess from "../pages/Authentication/kyc-success";
import KYCDeclined from "../pages/Authentication/kyc-declined";
import KYCFailure from "../pages/Authentication/kyc-failure";
import PropertyDetailsStatus from "../pages/Authentication/PropertyDetailsStatus";
import RegisterByCollaborator from "../pages/Authentication/Register-By-Collaborator";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

// Collaborator
import Collaborator from "../pages/Collaborator/index";
import CollaboratorUsersTransaction from "../pages/Collaborator/usersTransaction";

//KYC
import Kyc from "../pages/Kyc/kyc";
import Kyb from "../pages/Kyb/kyb";
import MyTransaction from "../pages/MyTransaction/MyTransaction";
import Portfolio from "../pages/Portfolio/Portfolio";
import MyWallet from "../pages/MyWallet/wallet";
import MyWithdrawal from "../pages/MyWallet/mywithdrawal";
import ClaimedFund from "../pages/ClaimedFund/index";
import PropertyClaimFund from "../pages/Portfolio/ClaimFund";

import Pages404 from "../pages/Utility/pages-404";

//new
import Signup from "../pages/Authentication/Register/Signup";
import SignupCollaborator from "../pages/Authentication/Register/SignupCollaborator";
import EmailVerification from "../pages/Authentication/Register/EmailVerification";
import AddPhone from "../pages/Authentication/Register/AddPhone";
import PhoneVerification from "../pages/Authentication/Register/PhoneVerification";
import PersonalDetails from "../pages/Authentication/Register/PersonalDetails";
import Address from "../pages/Authentication/Register/Address";
import Nationality from "../pages/Authentication/Register/Nationality";
import Tax from "../pages/Authentication/Register/Tax";
import TermsAndConditions from "../pages/Authentication/Register/TermsAndConditions";

import Notification from "../pages/Notification/Notification";


const authProtectedRoutes = [
  { path: "/dashboard", component: Dashboard },
  // { path: "/collaborator", component: Collaborator },
  {
    path: "/collaborator",
    component: (props) => (
      <ProtectedRoute component={Collaborator} personalDetailsRequired={true} {...props} />
    ),
  },
  { path: "/collaboratoruserstransaction/:id", component: CollaboratorUsersTransaction },
  // { path: "/dividends", component: Dividends },
  {
    path: "/dividends",
    component: (props) => (
      <ProtectedRoute component={Dividends} personalDetailsRequired={true} {...props} />
    ),
  },
  { path: "/profile", component: UserProfile },
  // { path: "/payment-preference", component: PaymentPreference },
    {
    path: "/payment-preference",
    component: (props) => (
      <ProtectedRoute component={PaymentPreference} personalDetailsRequired={true} {...props} />
    ),
  },
  { path: "/twofaauthenticator", component: Twofaauthenticator },
  { path: "/kyc", component: Kyc },
  { path: "/kyb", component: Kyb },
  { path: "/changepassword", component: Changepassword },
  // { path: "/properties", component: Properties },
  {
    path: "/properties",
    component: (props) => (
      <ProtectedRoute component={Properties} personalDetailsRequired={true} {...props} />
    ),
  },
  { path: "/property-details", component: PropertyDetails },
  { path: "/property-details/:id", component: PropertyDetails },
  // { path: "/mytransaction", component: MyTransaction },
  {
    path: "/mytransaction",
    component: (props) => (
      <ProtectedRoute component={MyTransaction} personalDetailsRequired={true} {...props} />
    ),
  },
  // { path: "/portfolio", component: Portfolio },
  {
    path: "/portfolio",
    component: (props) => (
      <ProtectedRoute component={Portfolio} personalDetailsRequired={true} {...props} />
    ),
  },
  // { path: "/wallet", component: MyWallet },
  {
    path: "/wallet",
    component: (props) => (
      <ProtectedRoute component={MyWallet} personalDetailsRequired={true} {...props} />
    ),
  },
  // { path: "/withdrawal", component: MyWithdrawal },
  {
    path: "/withdrawal",
    component: (props) => (
      <ProtectedRoute component={MyWithdrawal} personalDetailsRequired={true} {...props} />
    ),
  },
  // { path: "/claimed-fund", component: ClaimedFund },
  {
    path: "/claimed-fund",
    component: (props) => (
      <ProtectedRoute component={ClaimedFund} personalDetailsRequired={true} {...props} />
    ),
  },
  { path: "/property-claim-fund/:id", component: PropertyClaimFund },
  { path: "/notification", component: Notification },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: "/", exact: true, component: () => <Redirect to="/login" /> },
];

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/google-auth", component: Googleauth },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/change-password", component: ChangePwd },
  // { path: "/register", component: Register },
  // { path: "/register/:referral_code", component: Register },
  // { path: "/register/collaborator/:collaborator_referral_code", component: RegisterByCollaborator },
  { path: "/email-mobile-verification", component: MobileVerification },
  { path: "/kyc-details", component: KycDetails },
  { path: "/kyc-success", component: KYCSuccess },
  { path: "/kyc-declined", component: KYCDeclined },
  { path: "/kyc-failure", component: KYCFailure },
  { path: "/property-details-status/:status", component: PropertyDetailsStatus },

  { path: "/register", component: Signup },
  { path: "/register/:referral_code", component: Signup },
  { path: "/register/collaborator/:collaborator_referral_code", component: SignupCollaborator },
  { path: "/email-verification", component: EmailVerification },
  { path: "/add-phone", component: AddPhone },
  { path: "/phone-verification", component: PhoneVerification },
  { path: "/personal-details", component: PersonalDetails },
  { path: "/address", component: Address },
  { path: "/nationality", component: Nationality },
  { path: "/tax", component: Tax },
  { path: "/terms", component: TermsAndConditions },


  // // Wildcard route for unmatched routes
  // { path: "*", component: Pages404 },
];

export { authProtectedRoutes, publicRoutes };
